module.exports = __webpack_public_path__ + "img/tabiko.74d5e64e.png";